import React from 'react';
import { Localizer } from 'services/Localizer';
import { OrderItem } from 'features/commerce/shopping-cart/types';
import ProductPricing from 'shared/components/commerce/ProductPricing';
import ProductSelectionsList from 'features/commerce/shopping-cart/ProductSelectionsList';
import { dispatchRocEvent } from 'shared/hooks/useRocEventHandler';
import { ModelStatus } from '../../../../../Roc.SharedClientApp/types/model-status';

/**
 * Order details item component props
 */
interface OrderDetailsItemProps {
	item: OrderItem;
	index: number;
}

/**
 * Order details item component.
 * Renders the given item details for the my account order details page.
 */
export default function OrderDetailsItem(props: OrderDetailsItemProps) {
	const { item, index } = props;
	return (
		<>
			<td className="roc-manage-layout__table-col-img">
				{/*HCL region*/}
				<p className="roc-manage-layout__table-heading">
					{item?.product?.status === ModelStatus.Published ? (
						<a
							href={item.groupUrl ? item.groupUrl : item.url}
							onClick={() =>
								dispatchRocEvent('product-clicked', {
									productId: item.product.id,
									url: item.groupUrl ? item.groupUrl : item.url,
									productName: item.name,
									productGroupId: item.product.productGroupId,
								})
							}
						>
							<strong data-testid={`order-detail-item-${index}-name`}>{item.name}</strong>
						</a>
					) : (
						<strong>{item.name}</strong>
					)}
				</p>

				<ProductSelectionsList selections={item.selections} classNamePrefix="roc-order-details-item" />
				{/*endregion*/}

				{item?.product?.status === ModelStatus.Published ? (
					<a
						href={item.groupUrl ? item.groupUrl : item.url}
						onClick={() =>
							dispatchRocEvent('product-clicked', {
								productId: item.product.id,
								url: item.groupUrl ? item.groupUrl : item.url,
								productName: item.name,
								productGroupId: item.product.productGroupId,
							})
						}
					>
						<OrderDetailsItemImage
							thumbnailUrl={item.product?.thumbnailUrl}
							altText={item.product?.altText}
							productName={item.name}
						/>
					</a>
				) : (
					<OrderDetailsItemImage
						thumbnailUrl={item.product?.thumbnailUrl}
						altText={item.product?.altText}
						productName={item.name}
					/>
				)}
				{/*endregion*/}
			</td>
			{/*HCL region*/}
			<td>
				<p className="roc-manage-layout__table-heading">{Localizer('ItemNumber')}</p>
				<p className="roc-manage-layout__table-heading">
					{item?.product?.status === ModelStatus.Published ? (
						<a
							href={item.groupUrl ? item.groupUrl : item.url}
							onClick={() =>
								dispatchRocEvent('product-clicked', {
									productId: item.product.id,
									url: item.groupUrl ? item.groupUrl : item.url,
									productName: item.name,
									productGroupId: item.product.productGroupId,
								})
							}
						>
							<strong data-testid={`order-detail-item-${index}-sku`}>{item.sku}</strong>
						</a>
					) : (
						<strong>{item.sku}</strong>
					)}
				</p>
			</td>
			{/*endregion*/}

			{/* <td>
				<b>{Localizer('TrackingNumber')}:</b>
			</td>
			<td>TODO</td> */}
			{/*HCL region*/}
			<td>
				<p className="roc-manage-layout__table-heading">{Localizer('QuantityOrdered')}</p>
				<p>{item.quantityOrdered}</p>
			</td>
			<td>
				<p className="roc-manage-layout__table-heading">{Localizer('QuantityShipped')}</p>
				<p>{item.quantityShipped}</p>
			</td>
			<td>
				<p className="roc-manage-layout__table-heading">{Localizer('QuantityOnBackorder')}</p>
				<p>{item.quantityOnBackorder}</p>
			</td>
			{/*endregion*/}
			<td>
				<p className="roc-manage-layout__table-heading">{Localizer('ItemPrice')}</p>

				<ProductPricing className="roc-manage-layout__table-pricing" displayPrice={item.unitPrice} />
			</td>
		</>
	);
}

interface OrderDetailsItemImageProps {
	thumbnailUrl: string | null;
	altText?: string;
	productName: string;
}

export function OrderDetailsItemImage(props: OrderDetailsItemImageProps) {
	const { thumbnailUrl, altText, productName } = props;
	return (
		<img
			className="roc-manage-layout__table-img"
			src={thumbnailUrl || '/images/image-not-found-small.png'}
			alt={altText || productName}
		/>
	);
}
